import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar from '../Components/NavBar';
import "./PaymentPage.css";
import goBack from '../Icons/ep_arrow-up-bold.png';
import lockerDot from '../Icons/carbon_circle-filled.png';
import OrderDetails from '../Components/OrderDetails';

const Payment = () => {
    const navigate = useNavigate();
    const [locationConfirmed, setLocationConfirmed] = useState(false);

    // Function to navigate to the cart page
    const goToCart = () => {
        navigate('/cart'); // Adjust this route as needed
    };

    // Function to navigate to the landing page
    const goToLanding = () => {
        navigate('/'); // Adjust this route as needed
    };

    // Function to confirm location and change button state
    const confirmLocation = () => {
        setLocationConfirmed(true);
    };
    const handleCheckout = () => {
        navigate('/confirmationpage'); // Adjust this route as needed
    };

    return (
        <div>
            <NavBar />
            <div className="cart-back-and-forth-button">
                <div className="cart-button-payment" onClick={goToLanding}>
                    shop
                </div>
                <div className="back-button-payment" onClick={goToCart}>
                    <img src={goBack} alt="go_back" className="go-back" />
                </div>
                <div className="cart-button-payment" onClick={goToCart}>
                    cart
                </div>
                <div className="back-button-payment" onClick={goToCart}>
                    <img src={goBack} alt="go_back" className="go-back" />
                </div>
                <div className="cart-button2-payment">
                    payment
                </div>
            </div>
            <div className="checkout-title">
                Checkout
            </div>
            <div className="parent-of-payment-page">
                <div className="wrapper-of-payment-page">
                    <div className="select-pickup-closest-to-you">
                        Select the pickup location closest to you!
                    </div>
                    <div className="locker-box">
                        <div className="randomannoyingbox">
                            <img src={lockerDot} alt="locker_pick" className="locker-dot" />
                            <div className="locker-location-name">
                                USC Village
                            </div>
                        </div>
                        <div className="locker-location-name2">
                            Address, 90007
                        </div>
                        <div className={`confirm-loc-payment ${locationConfirmed ? "confirm-loc-active" : ""}`} onClick={confirmLocation}>
                            Confirm Location
                        </div>
                    </div>
                    <div class="payment-box-confirmation">
                        <div class="payment-method-confirmation">
                            Payment Method
                        </div>
                        <div class="enter-card-deets">
                            Enter card details
                        </div>
                        <div class="frame-188">
                            <div class="frame-175">
                                <div class="card-holder-name">
                                    Cardholder Name
                                </div>
                                <input class="random-beige-box">

                                </input>
                                <div class="card-holder-name">
                                    Card Number
                                </div>
                                <input class="random-beige-box">
                                </input>
                            </div>

                        </div>
                        <div class="frame-180">
                            <div>
                                <div class="expiry-date">
                                    Expiry Date
                                </div>
                                <input class="expiry-date-box">

                                </input>
                            </div>
                            <div>
                                <div class="expiry-date">
                                    Expiry Date
                                </div>
                                <input class="expiry-date-box">

                                </input>
                            </div>
                            <div>
                                <div class="expiry-date">
                                    Expiry Date
                                </div>
                                <input class="expiry-date-box">
                                </input>
                            </div>
                        </div>
                        <div class="frame-175">
                            <div class="card-holder-name">
                                Billing Address (Street Address)
                            </div>
                            <input class="random-beige-box">

                            </input>
                            <div class="card-holder-name">
                                Apt, Unit, Suite, etc (optional)
                            </div>
                            <input class="random-beige-box">
                            </input>
                            <div class="card-holder-name">
                                Country
                            </div>
                            <input class="random-beige-box">

                            </input>
                        </div>
                        <div class="frame-180">
                            <div>
                                <div class="expiry-date">
                                    City
                                </div>
                                <input class="expiry-date-box">

                                </input>
                            </div>
                            <div>
                                <div class="expiry-date">
                                    State
                                </div>
                                <input class="expiry-date-box">

                                </input>
                            </div>
                            <div>
                                <div class="expiry-date">
                                    Zip Code
                                </div>
                                <input class="expiry-date-box">
                                </input>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="checkoutandorderwrapper">
                    <div class="order-details-payment-wrapper">
                        <OrderDetails></OrderDetails>
                    </div>
                    <button className='checkout2' onClick={handleCheckout}>Checkout</button>
                    
                </div>
            </div>
        </div >
    );
};

export default Payment;
